import React from 'react';
import Sidennav from '../dashboard/sidenavbar';
import Topnavbar from '../dashboard/topnavbar';
import { useState, useEffect } from 'react';
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { baseurladdress } from "../baseurl";
import $ from 'jquery';
import { Modal, Button, ModalHeader, ModalFooter } from "react-bootstrap";
import "datatables.net-dt/js/dataTables.dataTables";
import "datatables.net-dt/css/jquery.dataTables.min.css";

function Menu({ refresh }) {
    const [data, setData] = useState([]);
    const accessuserid = localStorage.getItem("id");

    const accesstoken = localStorage.getItem("token");
    const navigate = useNavigate();
    const Swal = require('sweetalert2')
    const [showModal, setShowModal] = useState(false);
    const [edshowModal, setedShowModal] = useState(false);
    const [pgm, setpgm] = useState([]);
    const [pgm_menu, setpgm_menu] = useState("");
    const [pgm_url, setpgm_url] = useState("");
    const [pgm_icon, setpgm_icon] = useState("");
    const [pgm_parent, setpgm_parent] = useState("");
    const [pgm_parentname, setpgm_parentname] = useState("");

    const [edpgm_menu, setedpgm_menu] = useState("");
    const [edpgm_url, setedpgm_url] = useState("");
    const [edpgm_icon, setedpgm_icon] = useState("");
    const [edserial, setedserial] = useState("");
    const [pgmId, setpgmId] = useState("");
    const [edpgm_parentname, setedpgm_parentname] = useState("");
    const [menu, setmenu] = useState("");
    const [menuOptions, setmenuOptions] = useState([]);

    const [menu_status, setmenu_status] = useState("");
    const [x, setX] = useState("");
    const [xy, setXY] = useState("");

    const [refreshSidebar, setRefreshSidebar] = useState(false);
    // const [Refreshmenu, setRefreshmenu] = useState(false);

    const handleRefreshSidebar = () => {
        setRefreshSidebar(prev => !prev); // Toggle to trigger refresh
    };

    // const handleRefreshmenu = () => {
    //     setRefreshmenu(prev => !prev); // Toggle to trigger refresh
    // };
    $(function () {
        setTimeout(function () {
            $('#menu').DataTable();
        }, 1000);
    });

    const handleclick = () => {
        setShowModal(true);
        getprms();
    };

    const getprms = () => {
        axios.get(baseurladdress + `getprograms`, {
            headers: { Authorization: `Bearer ${accesstoken}` },
        })
            .then(res => {
                console.log("Response:", res.data);
                const raw = res.data.response;
                const formatted = raw.map(p => ({
                    id: p.pgm_id,
                    name: p.pgm_menu
                }));
                setpgm(formatted);
            })
            .catch(error => {
                alert(error);
            });
    };

    // List all menu
    const GetAllmenu = () => {
        axios
            .get(baseurladdress + `findallmenu`, {
                headers: { Authorization: `Bearer ${accesstoken}` },
            })
            .then((res) => {
                const datas = res.data.response;
                console.log("itemss" + datas);
                const user = datas.map((item, index) => (
                    <tr id={"chk" + item.pgm_id}>
                        <td>{index + 1}</td>
                        <td>{item.pgm_menu}</td>
                        <td>{item.pgm_url}</td>
                        {/* <td>{item.pgm_icon}</td> */}
                        <td>
                            <i className={`fa ${item.pgm_icon}`} style={{ marginRight: '8px', color: 'brown' }}></i>
                            {item.pgm_icon}
                        </td>

                        <td>{item.pgm_parentname && item.pgm_parentname.trim() !== "" ? item.pgm_parentname : "#"}</td>
                        <td>
                            <div>
                                {(() => {
                                    if (item.pgm_status == 0) {
                                        return (
                                            <div>
                                                <span class="badge bg-danger" >
                                                    Inactive
                                                </span>
                                            </div>
                                        );
                                    } else if (item.pgm_status == 1) {
                                        return (
                                            <div><span class="badge bg-success">Active</span></div>
                                        )
                                    } else if (item.pgm_status ==2){
                                        return(
                                            <div><span className='badge bg-warning'>Active</span></div>
                                        )
                                    }
                                })()}
                            </div>
                        </td>
                        <td style={{ textAlign: "center" }}>
                            <i
                                class="text-primary fa fa-edit"
                                style={{ cursor: "pointer" }}
                                onClick={() => handleEditClick(item.pgm_id)}
                            ></i>
                        </td>
                        <td style={{ textAlign: "center" }}>
                            <i
                                class="text-danger fa fa-trash"
                                style={{ cursor: "pointer" }}
                                onClick={() => handleDelete(item.pgm_id)}
                            ></i>
                        </td>
                    </tr>
                ));
                setData(user);
            })
            .catch((error) => {
                alert(error);
            });
    };
    useEffect(() => {
        GetAllmenu();
        
    }, [refresh]);

    const handleSubmit = (e) => {
        e.preventDefault();
        const data = {
            pgm_menu: pgm_menu,
            pgm_url: pgm_url,
            pgm_icon: pgm_icon,
            pgm_parent: pgm_parent,
            pgm_parentname: pgm_parentname,
            pgm_crtdby: accessuserid,
        };
        axios
            .post(baseurladdress + `addmenu`, data, {
                headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
            })
            .then((res) => {
                if (res.data.status === "success") {
                    const Toast = Swal.mixin({
                        toast: true,
                        position: "top-end",
                        showConfirmButton: false,
                        timer: 2500,
                        timerProgressBar: true,
                        didOpen: (toast) => {
                            toast.addEventListener("mouseenter", Swal.stopTimer);
                            toast.addEventListener("mouseleave", Swal.resumeTimer);
                        },
                    });
                    Toast.fire({
                        icon: "success",
                        title: " added successfully",
                    });
                    handleRefreshSidebar();
                   
                    setShowModal(false);
                    setpgm_menu("");
                    setpgm_url("");
                    setpgm_icon("");
                    setpgm_parent("");
                   GetAllmenu();
                } else {
                    alert("Failed");
                }
            })
            .catch((error) => {
                alert(error);
            });
    };

    const getmenu = () => {
        axios.get(baseurladdress + `findallmenu`, {
            headers: { Authorization: `Bearer ${accesstoken}` },
        })
            .then(res => {
                const data = res.data.response;
                console.log(data);
                const formattedOptions = data.map((item) => ({
                    id: item.pgm_id,
                    name: item.pgm_menu
                }));
                setmenuOptions(formattedOptions);
            })
            .catch(error => {
                alert(error);
            });
    };

    useEffect(() => {
        getmenu();
    }, []);

    const handleEditClick = (pgmId) => {
        setedShowModal(true);
        setpgmId(pgmId);
        console.log(pgmId, "hjgh");
        axios
            .get(baseurladdress + `editmenu/` + pgmId, {
                headers: { Authorization: `Bearer ${accesstoken}` },
            })
            .then((res) => {
                const data = res.data.response;
                setedpgm_menu(data[0].pgm_menu);
                setedpgm_url(data[0].pgm_url);
                setedpgm_icon(data[0].pgm_icon);
                setedserial(data[0].pgm_serial);
                setmenu_status(data[0].pgm_status);
                setXY(data[0].pgm_status);
                const check = (data[0].pgm_status == "1") ? true : false;
                setX(check);
                setmenu(data[0].pgm_parent);
            })
            .catch((error) => {
                alert(error);
            });
    };

    const handleUpdate = (e) => {
        e.preventDefault();
        var data = {
            pgm_menu: edpgm_menu,
            pgm_url: edpgm_url,
            pgm_icon: edpgm_icon,
            pgm_serial: edserial,
            pgm_parent: menu,
            pgm_parentname: edpgm_parentname,
            pgm_status: menu_status,
            pgm_updtby: accessuserid,
            pgm_id: pgmId,
        };
        axios
            .post(baseurladdress + `updatemenu`, data, {
                headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
            })
            .then((result) => {
                console.log("reslt:", result);
                const Data = result.data.status;
                if (Data == "success") {
                    const Toast = Swal.mixin({
                        toast: true,
                        position: "top-end",
                        showConfirmButton: false,
                        timer: 2500,
                        timerProgressBar: true,
                        didOpen: (toast) => {
                            toast.addEventListener("mouseenter", Swal.stopTimer);
                            toast.addEventListener("mouseleave", Swal.resumeTimer);
                        },
                    });
                    Toast.fire({
                        icon: "success",
                        title: "Data Updated successfully",
                    });
                    handleRefreshSidebar();
                    setedShowModal(false);
                    GetAllmenu();
                }
            });
    };

    function handleDelete(pgmId) {
        Swal.fire({
            title: "Are you sure?",
            text: "You won't be able to revert this!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085D6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes, delete it!",
        }).then((result) => {
            if (result.isConfirmed) {
                {
                    axios
                        .post(baseurladdress + `deletemenu/` + pgmId, data, {
                            headers: {
                                Authorization: `Bearer ${localStorage.getItem("token")}`,
                            },
                        })
                        .then((result) => {
                            console.log("reslt:", result);
                            const Data = result.data.status;
                            if (Data == "deleted") {
                                const Toast = Swal.mixin({
                                    toast: true,
                                    position: "top-end",
                                    showConfirmButton: false,
                                    timer: 2500,
                                    timerProgressBar: true,
                                    didOpen: (toast) => {
                                        toast.addEventListener("mouseenter", Swal.stopTimer);
                                        toast.addEventListener("mouseleave", Swal.resumeTimer);
                                    },
                                });
                                Toast.fire({
                                    icon: "success",
                                    title: "Menu data Deleted Successfully",
                                });
                                GetAllmenu();
                            }
                        });
                }
            }
        });
    }

    return (
        <div>
            <Topnavbar />
            <Sidennav refresh={refreshSidebar} />
            <div className="content-wrap">
                <div className="main">
                    <div className="container-fluid">
                        <section id="main-content">
                            <div class="card">
                                <div class="card-header" style={{ "color": "black" }}>
                                    <h6 class="card-title"> MENU DETAILS
                                    </h6>
                                    <div className="d-flex align-items-center">
                                        <button
                                            type="button"
                                            className="btn plus-icon d-flex align-items-center"
                                            style={{ marginRight: '50px' }} onClick={handleclick}
                                        >
                                            <span style={{ fontSize: "1.2rem" }}><i className='fa fa-plus-circle text-success'></i></span>
                                            <span style={{ fontSize: "0.7rem", color: "black", padding: "5px" }}> Add</span>
                                        </button>
                                    </div>
                                </div>
                                <div class="card-body">
                                    <div className="col-lg-12">
                                        <div className="card">
                                            <div className="card-body">
                                                <div className="table-responsive">
                                                    <table className="table table-bordered table-responsive-sm" id="menu">
                                                        <thead className='text-center'>
                                                            <tr>
                                                                <th>Sl.No</th>
                                                                <th>Program Name</th>
                                                                <th>URL</th>
                                                                <th>Icon</th>
                                                                <th>Parent</th>
                                                                <th>Status</th>
                                                                <th>Edit</th>
                                                                <th>Delete</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>{data}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <Modal className="modal-size md modal-top-center" show={showModal} style={{ display: "flex" }} size="lg"
                                    centered >
                                    <Modal.Header>
                                        <h6>ADD MENU</h6>
                                        <span
                                            aria-hidden="true"
                                            style={{ cursor: "pointer" }}
                                            onClick={() => setShowModal(false)}
                                        >
                                            ×
                                        </span>
                                    </Modal.Header>
                                    <Modal.Body className="css">
                                        <form >
                                            <div className="row">
                                                <div className="col-md-3">
                                                    <h6>Menu Name</h6>
                                                    <input
                                                        text="text"
                                                        className="form-control"
                                                        value={pgm_menu}
                                                        onChange={(e) => setpgm_menu(e.target.value)}

                                                    ></input>
                                                </div>
                                                <div className="col-md-3">
                                                    <h6>URL</h6>
                                                    <input
                                                        text="text"
                                                        className="form-control"
                                                        value={pgm_url}
                                                        onChange={(e) => setpgm_url(e.target.value)}
                                                    ></input>
                                                </div> <div className="col-md-3">
                                                    <h6>Icon</h6>
                                                    <input
                                                        text="text"
                                                        className="form-control"
                                                        value={pgm_icon}
                                                        onChange={(e) => setpgm_icon(e.target.value)}

                                                    ></input>
                                                </div>
                                                <div className="col-md-3">
                                                    <h6>Program Name</h6>
                                                    <select
                                                        className="form-control select"
                                                        value={pgm_parent}
                                                        onChange={e => {
                                                            const selectedId = e.target.value;
                                                            setpgm_parent(selectedId);
                                                            const selectedProgram = pgm.find(p => p.id.toString() === selectedId);
                                                            setpgm_parentname(selectedProgram ? selectedProgram.name : "");
                                                        }}
                                                        required
                                                    >
                                                        <option value="" disabled>Select</option>
                                                        {pgm.map(p => (
                                                            <option key={p.id} value={p.id}>
                                                                {p.name}
                                                            </option>
                                                        ))}
                                                    </select>
                                                </div>
                                            </div>
                                        </form>
                                    </Modal.Body>
                                    <ModalFooter>
                                        <div className="row w-100">
                                            <div className="col-auto ml-auto">
                                                <button
                                                    type="button"
                                                    className="btn btn-primary"
                                                    id="save"
                                                    onClick={handleSubmit}
                                                >
                                                    SAVE
                                                </button>
                                            </div>
                                        </div>
                                    </ModalFooter>
                                </Modal>

                                {/* Edit */}
                                <Modal className="modal-size md modal-top-center" show={edshowModal} style={{ display: "flex" }} size="lg"
                                    centered >
                                    <Modal.Header>
                                        <h6>EDIT MENU</h6>
                                        <span
                                            aria-hidden="true"
                                            style={{ cursor: "pointer" }}
                                            onClick={() => setedShowModal(false)}
                                        >
                                            ×
                                        </span>
                                    </Modal.Header>
                                    <Modal.Body className="css">
                                        <form >

                                            <div className="row">
                                                <div className="col-md-4">
                                                    <h6>Menu Name</h6>
                                                    <input
                                                        text="text"
                                                        className="form-control"
                                                        value={edpgm_menu}
                                                        onChange={(e) => setedpgm_menu(e.target.value)}
                                                    ></input>
                                                </div>
                                                <div className="col-md-4">
                                                    <h6>URL</h6>
                                                    <input
                                                        text="text"
                                                        className="form-control"
                                                        value={edpgm_url}
                                                        onChange={(e) => setedpgm_url(e.target.value)}
                                                    ></input>
                                                </div>
                                                <div className="col-md-4">
                                                    <h6>Icon</h6>
                                                    <input
                                                        text="text"
                                                        className="form-control"
                                                        value={edpgm_icon}
                                                        onChange={(e) => setedpgm_icon(e.target.value)}
                                                    ></input>
                                                </div>
                                                <div className="col-md-4">
                                                    <h6>Serial</h6>
                                                    <input
                                                        text="text"
                                                        className="form-control"
                                                        value={edserial}
                                                        onChange={(e) => setedserial(e.target.value)}
                                                    ></input>
                                                </div>
                                                <div className="col-md-4">
                                                    <h6>Program Name</h6>
                                                    <select
                                                        className="form-control select"
                                                        value={menu}
                                                        onChange={(e) => {
                                                            const selectedId = e.target.value;
                                                            const selectedItem = menuOptions.find(item => item.id == selectedId);
                                                            setmenu(selectedId);
                                                            setedpgm_parentname(selectedItem ? selectedItem.name : "");
                                                        }}
                                                        required
                                                    >
                                                        <option value="">Select</option>
                                                        {menuOptions.map(item => (
                                                            <option key={item.id} value={item.id}>
                                                                {item.name}
                                                            </option>
                                                        ))}
                                                    </select>
                                                </div>
                                                <div class="col-sm-4 mt-2 mt-sm-0">
                                                    <br />
                                                    <input type="checkbox" name="menu_status" className="selectsingle checku" checked={x} value={xy} id="exampleCheck1"
                                                        onClick={() => { setX(!x); }}
                                                        onChange={(event) => {
                                                            var checked = event.target.checked; if (checked == true) { setmenu_status(1); }
                                                            else { setmenu_status(0); }
                                                        }} /><label className="form__label textal offset-1" for="clienttype">
                                                        Status
                                                    </label>
                                                </div>
                                            </div>
                                        </form>
                                    </Modal.Body>
                                    <ModalFooter>
                                        <div className="row w-100">
                                            <div className="col-auto ml-auto">
                                                <button
                                                    type="button"
                                                    className="btn btn-primary"
                                                    id="save"
                                                    onClick={handleUpdate}
                                                >
                                                    SAVE
                                                </button>
                                            </div>
                                        </div>
                                    </ModalFooter>
                                </Modal>
                            </div>
                        </section>
                    </div>
                </div>
            </div >
        </div >
    );
}
export default Menu;
